import { YES_NO } from "../assessment-constant";
import { FreeTextScreenerDef } from "../assessment-types";

export const OBESITY_SCREENER: FreeTextScreenerDef = {
  questions: [
    { questionId: 1, kind: "yesNo", audience: "PATIENT", options: YES_NO },
    { questionId: 2, kind: "yesNo", audience: "PATIENT", options: YES_NO },
    {
      questionId: 3,
      kind: "single",
      audience: "PATIENT",
      options: ["< 1 year", "1-5 years", "5-10 years", "> 10 years"],
    },
    {
      questionId: 4,
      kind: "multi",
      audience: "PATIENT",
      options: [
        "Fast food",
        "Fried foods",
        "Sugary drinks",
        "Sweets or desserts",
        "Late night eating",
        "Daily fruits or vegetables",
      ],
    },
    { questionId: 7, kind: "yesNo", audience: "PROVIDER", options: YES_NO },
    {
      questionId: 8,
      kind: "multi",
      audience: "PROVIDER",
      options: ["15 Minutes"],
    },
    {
      questionId: 5,
      kind: "single",
      audience: "PATIENT",
      options: ["Mostly home cooked", "Mostly take-out/restaurant", "Mixed"],
    },
    {
      questionId: 6,
      kind: "multi",
      audience: "PATIENT",
      options: [
        "Lack of time",
        "Cost of healthy food",
        "Stress / emotional eating",
        "Pain / limited mobility",
        "Fatigue",
        "Lack of motivation",
        "Family / social habits",
      ],
    },
  ],
};
